var map = {
	"./template.bet575": 2032,
	"./template.bet575.tsx": 2032,
	"./template.bet777": 2033,
	"./template.bet777.tsx": 2033,
	"./template.betbetbet": 1998,
	"./template.betbetbet.tsx": 1998,
	"./template.betgalaxy": 1157,
	"./template.betgalaxy.tsx": 1157,
	"./template.betprofessor": 2034,
	"./template.betprofessor.tsx": 2034,
	"./template.betroyale": 2035,
	"./template.betroyale.tsx": 2035,
	"./template.betstride": 2036,
	"./template.betstride.tsx": 2036,
	"./template.buffalobet": 2037,
	"./template.buffalobet.tsx": 2037,
	"./template.chromabet": 2038,
	"./template.chromabet.tsx": 2038,
	"./template.default": 662,
	"./template.default.tsx": 662,
	"./template.epicodds": 2039,
	"./template.epicodds.tsx": 2039,
	"./template.fiestabet": 1999,
	"./template.fiestabet.tsx": 1999,
	"./template.forsport": 1158,
	"./template.forsport.tsx": 1158,
	"./template.gigabet": 2040,
	"./template.gigabet.tsx": 2040,
	"./template.goldenbet888": 1986,
	"./template.goldenbet888.tsx": 1986,
	"./template.goldenrush": 2041,
	"./template.goldenrush.tsx": 2041,
	"./template.hyperbet": 2042,
	"./template.hyperbet.tsx": 2042,
	"./template.juicybet": 2043,
	"./template.juicybet.tsx": 2043,
	"./template.junglebet": 2044,
	"./template.junglebet.tsx": 2044,
	"./template.magnumbet": 2045,
	"./template.magnumbet.tsx": 2045,
	"./template.oldgill": 2000,
	"./template.oldgill.tsx": 2000,
	"./template.puntcity": 2001,
	"./template.puntcity.tsx": 2001,
	"./template.puntgenie": 2046,
	"./template.puntgenie.tsx": 2046,
	"./template.pyramidbet": 1987,
	"./template.pyramidbet.tsx": 1987,
	"./template.questbet": 2002,
	"./template.questbet.tsx": 2002,
	"./template.slambet": 2003,
	"./template.slambet.tsx": 2003,
	"./template.sterlingparker": 1159,
	"./template.sterlingparker.tsx": 1159,
	"./template.sugarcastle": 2047,
	"./template.sugarcastle.tsx": 2047,
	"./template.templebet": 2048,
	"./template.templebet.tsx": 2048,
	"./template.titanbet": 2049,
	"./template.titanbet.tsx": 2049,
	"./template.ts": 382,
	"./template.vikingbet": 2004,
	"./template.vikingbet.tsx": 2004,
	"./template.volcanobet": 1984,
	"./template.volcanobet.tsx": 1984,
	"./template.wellbet": 2050,
	"./template.wellbet.tsx": 2050
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2437;